import React, { lazy, Suspense, ComponentType } from 'react'

interface LoadableOptions {
  loader: () => Promise<{ default: ComponentType<any> }>
  loading: ComponentType<any>
}

/**
 * A modern replacement for react-loadable using React.lazy and Suspense.
 * This is compatible with React 18 and doesn't use deprecated contextTypes.
 */
export const Loadable = ({ loader, loading: LoadingComponent }: LoadableOptions) => {
  const LazyComponent = lazy(loader)

  return (props: any) => (
    <Suspense fallback={<LoadingComponent />}>
      <LazyComponent {...props} />
    </Suspense>
  )
}

export default Loadable
